module.exports = __webpack_public_path__ + "img/img01.2c228a5d.jpeg";